import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IStampsOfferViewRating } from '@/shared/model/stamps-offer-view-rating.model';

const baseApiUrl = 'api/stamps-offer-view-ratings';
const baseSearchApiUrl = 'api/_search/stamps-offer-view-ratings?query=';

export default class StampsOfferViewRatingService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IStampsOfferViewRating> {
    return new Promise<IStampsOfferViewRating>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IStampsOfferViewRating): Promise<IStampsOfferViewRating> {
    return new Promise<IStampsOfferViewRating>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IStampsOfferViewRating): Promise<IStampsOfferViewRating> {
    return new Promise<IStampsOfferViewRating>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
